'use strict';

var React = require('react');
var _ = require('lodash');
module.exports = function () {
    return React.createElement('span', {
        'className': this.props.getClassName('has-tooltip'),
        'onMouseEnter': this.props.openOnMouseEnter && this.open,
        'onMouseLeave': this.props.closeOnMouseLeave && this.close
    }, this.props.customTrigger ? null : this.props.children);
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/tooltip.rt.js